import { type FC, type ReactNode, createContext, useContext } from 'react';

import type { AsyncJobSummary } from '@core/types/api/AsyncJobSummary/AsyncJobSummary';
import type Enums from '@core/types/api/Enums';

import type { AsyncJobStatusConfig } from './AsyncJobStatusConfig';
import { useAsyncJobStatus } from './useAsyncJobStatus';

type Props = {
  job: AsyncJobSummary | null;
  config: AsyncJobStatusConfig | null;
  isCurrentlyActive: boolean;
  dismiss: () => void;
  trackJob: (jobId: string, jobType: Enums.AsyncJobType) => void;
};

const AsyncJobStatusContext = createContext<Props | null>(null);

export const AsyncJobStatusProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const value = useAsyncJobStatus();

  return <AsyncJobStatusContext.Provider value={value}>{children}</AsyncJobStatusContext.Provider>;
};

export const useAsyncJobStatusContext = (): Props => {
  const ctx = useContext(AsyncJobStatusContext);
  if (ctx === null) {
    throw new Error('useAsyncJobStatusContext must be used within an AsyncJobStatusProvider');
  }
  return ctx;
};
